const clockHours = [
  // '12:00 am',
  // '1:00 am',
  // '2:00 am',
  // '3:00 am',
  // '4:00 am',
  // '5:00 am',
  // '6:00 am',
  // '7:00 am',
  // '8:00 am',
  // '9:00 am',
  '10:00 am',
  '11:00 am',
  '12:00 pm',
  '1:00 pm',
  '2:00 pm',
  '3:00 pm',
  '4:00 pm',
  // '5:00 pm',
  // '6:00 pm',
  // '7:00 pm',
  // '8:00 pm',
  // '9:00 pm',
  // '10:00 pm',
  // '11:00 pm',
];
export const CALENDAR_WEEK_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const CALENDAR_VIEWS = ['month', 'week', 'day'];

export const US_STATES = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

// Cookies
export const AUTH_TOKEN = 'access-token';

// Routes
export const HOME = '/';
export const ORDER = '/order';
export const CATERING = '/catering';
export const CREATE_ORDER = '/create_order';

// Callback
export const CALLBACK = '/callback';

export const COMPLETE_ORDER = '/completed_order';

export const SCHEDULE = '/my';
export const LOGIN = '/login';
export const SIGNUP = '/signup';
export const MY_PROFILE = '/profile';
export const EDIT_SERVICES = '/services';
export const MY_SETTINGS = '/settings';
export const STORY = '/our-story';
export const NUTRITION = '/nutrition';
export const SUPPORT = '/support';
export const PRODUCT = '/product/:id';

export const PRIVACY_POLICY = '/privacypolicy';
export const TERMS_CONDITIONS = '/termsandconditions';

// Modals
export const MODAL_KEY = {
  L_DRAWER: 'nav_menu',
  R_DRAWER: 'local_cart',
  EDIT_ADDRESS: 'edit_address',
  SIGN_UP: 'signup',
  DATE_PICKER: 'date-picker',
  DETAIL_SERVICE: 'service_detail',
  NEW_APPT: 'appt_new',
  PAYMENT_PORTAL: 'payment',
  LOCATION_POPOVER: 'LOCATION_POPOVER',
  CONFIRM_USE_DEFAULT_ADDRESS: 'CONFIRM_USE_DEFAULT_ADDRESS',
  LEAVE_UNFINISHED_BOX: 'LEAVE_UNFINISHED_BOX',
};

// Mime Abbr
export const MIME_ABBR: { [key: string]: string } = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/heic': 'heic',
};
